import axios from './productInstance'

const saveShapeProfile = async (data: any) => {
  try {
    const hasId = !!data?.id
    const res = hasId
      ? await axios.put(`/shapeprofiles/`, data)
      : await axios.post(`/shapeprofiles/`, data)

    return res.data
  } catch (error) {
    console.error('Error saving shape profile data:', error)
    return error
  }
}

export default saveShapeProfile
